import React from 'react';
import { FormControl } from 'react-bootstrap';

export class StoreDropdown extends React.Component {
    render() {
        return (
            <div style={{ display: 'inline-block', marginRight: '10px', width: '250px' }} >
                {this.props.stores.length === 1 &&
                    <span style={{ marginRight: '20px' }} >{this.props.stores[0].customer_Name}</span>
                }
                {this.props.stores.length > 1 &&
                    <FormControl
                        componentClass="select"
                        value={this.props.storeId}
                        name={this.props.storeId}
                        onChange={this.props.onChangeStore}
                    >
                        {this.props.stores.map((store) =>
                            <option key={store.storeId} value={store.storeId}>{store.customer_Name}</option>
                        )}
                    </FormControl>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SalesOrder/StoreDropdown.js